import { HttpClient } from "@angular/common/http";
import { CustomTranslateLoader } from "./customTranslateLoader";
import { TranslationModuleEnum } from "./translation-modules.enum";
import { sharedModules } from "./translateModules";

const createLoaderModule = (
  http: HttpClient,
  modules: TranslationModuleEnum[],
  isPublicAPI: boolean = false
) => {
  return new CustomTranslateLoader(http, modules, isPublicAPI);
};

export const createTranslateSharedLoader = (http: HttpClient) => {
  return createLoaderModule(http, sharedModules, true);
};

export const createTranslateDashboardLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.dashboard]);
};

export const createTranslatePlanningLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Performance_Planning]);
};

export const createTranslatePerformaneReportsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.performanceReports]);
};

export const createTranslateChangeRequestsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.changeRequests]);
};

export const createTranslateClosureRequestsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.closureRequests]);
};

export const createTranslateEppmRequestsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.eppmRequests]);
};

export const createTranslateEppmInitiationFormLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.initiationForm]);
};

export const createTranslateCommitteeLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.committee]);
};

export const createTranslateBauLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.BAU]);
};

export const createTranslateGroupsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.groups]);
};

export const createTranslateAgentQueueLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.agentQueue]);
};

export const createTranslateManageServicesLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.manageServices]);
};

export const createTranslateManageScorecardsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.ManageScorecards]);
};

export const createTranslatePerformanceSharedLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Performance_Shared]);
};

export const createTranslateManageFormsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.manageForms]);
};

export const createTranslateMeetingsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [
    TranslationModuleEnum.Meetings,
    TranslationModuleEnum.followUp,
  ]);
};

export const createTranslateFollowupLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.followUp]);
};

export const createTranslateRequestsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.requests]);
};

export const createTranslateUsersLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.users]);
};

export const createTranslateServiceCatalogLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.serviceCatalog]);
};

export const createTranslateRolesLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.roles]);
};

export const createTranslatePerfChngeRequestLoader = (http: HttpClient) => {
  return createLoaderModule(http, [
    TranslationModuleEnum.Performance_ChangeRequest,
    TranslationModuleEnum.Performance_Planning,
  ]);
};

export const createTranslateProjectsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Projects]);
};

export const createTranslateEntityDesignerLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.entityDesigner]);
};

export const createScoreSubmissionLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.scoreSubmission]);
};

export const createTranslateConfigurationLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.configuration]);
};

export const createTranslateLookupLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.lookups]);
};

export const createTranslatePerformanceDashboardLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.performanceDashboard]);
};

export const createTranslateOverallStrategyPerformance = (http: HttpClient) => {
  return createLoaderModule(http, [
    TranslationModuleEnum.overallStrategyPerformance,
  ]);
};

export const createTranslateCommitteesManagementLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Committee_Management]);
};

export const createTranslateInnovationManagementLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Innovation]);
};

export const createTranslateEventsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Events]);
};

export const createTranslateJobsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.jobs]);
};

export const createTranslateSettingsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.settings]);
};

export const createTranslateVolunteerLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.volunteer]);
};

export const createTranslateMediaCenterLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.mediaCenter]);
};

export const createTranslateCompetitionLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.competition]);
};

export const createTranslateMembershipLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.membership]);
};

export const createTranslateBookingLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.booking]);
};

export const createTranslateEventRegistrationLoader = (http: HttpClient) => {
  return createLoaderModule(
    http,
    [TranslationModuleEnum.Event_Registration],
    true
  );
};

export const createTranslateDelegationsLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.delegations]);
};

export const createTranslateServicesDashboardLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.servicesDashboard]);
};

export const createTranslateProcessLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Admin_Process]);
};

export const createTranslateEServicesLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.EServices]);
};

export const createTranslateEACoursesLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Appraisal]);
};
export const createTranslatePartnershipLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.Partnership]);
};
export const createTranslateCmsManagementLoader = (http: HttpClient) => {
  return createLoaderModule(http, sharedModules);
};

export const createTranslateDonationsManagementLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.donation]);
};
export const createTranslateLoyalityManagementLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.loyalty]);
};

export const createTranslateContentManagementLoader = (http: HttpClient) => {
  return createLoaderModule(http, [TranslationModuleEnum.contentManagement]);
};
